export const getQuoteId = (quoteId: number | string): string => {
  return `quote-${quoteId}`
}
